var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { plainToClass, plainToInstance } from 'class-transformer';
import queries from 'constants/queries';
import { DoctorSchedule, PaginationMetaData } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from './ApiService';
var DoctorScheduleService = /** @class */ (function (_super) {
    __extends(DoctorScheduleService, _super);
    function DoctorScheduleService() {
        var _this = _super.call(this) || this;
        _this.root = 'doctor_schedules';
        _this.successMessage = '';
        return _this;
    }
    DoctorScheduleService.prototype.useDoctorSchedules = function (pageNumber, filters) {
        var _this = this;
        if (pageNumber === void 0) { pageNumber = 1; }
        if (filters === void 0) { filters = {}; }
        return useQuery([queries.doctorSchedules, pageNumber, filters], function () {
            return _this.get(_this.root, __assign(__assign({}, filters), { page: pageNumber }));
        }, {
            keepPreviousData: true,
            select: function (_a) {
                var data = _a.data;
                var doctorSchedules = plainToInstance(DoctorSchedule, data === null || data === void 0 ? void 0 : data.doctor_schedules);
                var meta = plainToClass(PaginationMetaData, data === null || data === void 0 ? void 0 : data.meta);
                return { doctorSchedules: doctorSchedules, meta: meta };
            }
        });
    };
    DoctorScheduleService.prototype.useDoctorSchedule = function (id, enabled) {
        var _this = this;
        return useQuery([queries.doctorSchedule, id], function () {
            return _this.get("".concat(_this.root, "/").concat(id));
        }, {
            enabled: enabled && id != null && id > 0,
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToClass(DoctorSchedule, __assign({}, data));
            }
        });
    };
    DoctorScheduleService.prototype.useCreateDoctorSchedule = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var successMessage = _a.successMessage, doctorSchedule = _a.doctorSchedule;
            _this.successMessage = successMessage;
            return _this.post(_this.root, {
                data: { doctor_schedule: doctorSchedule.toRequestBody('create') }
            });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.doctorSchedules);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    DoctorScheduleService.prototype.useUpdateDoctorSchedule = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var successMessage = _a.successMessage, doctorSchedule = _a.doctorSchedule;
            _this.successMessage = successMessage;
            var id = doctorSchedule.getId();
            return _this.put("".concat(_this.root, "/").concat(id), {
                data: { doctor_schedule: doctorSchedule.toRequestBody('update') }
            });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.doctorSchedules);
                queryClient.invalidateQueries(queries.doctorSchedule);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    DoctorScheduleService.getInstance = function () {
        if (!DoctorScheduleService.instance) {
            DoctorScheduleService.instance = new DoctorScheduleService();
        }
        return DoctorScheduleService.instance;
    };
    return DoctorScheduleService;
}(ApiService));
export default DoctorScheduleService;
